module.exports = function() {
  return new Worker(__webpack_public_path__ + "eb1f4c4940cf6c7eaf2e.worker.js");
};